import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm';
import Image from '../../components/common/Image';
import { TaskyAuthLayout } from '../../components/tasky';

const ForgotPasswordPage: React.FC = () => {
  return (
    <TaskyAuthLayout
      logo={<Image category="common" fileName="logo.png" alt="ロゴ" className="h-10 w-auto" />}
      footer={
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-sm text-primary hover:text-primary-hover font-medium transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          ログイン画面に戻る
        </Link>
      }
    >
      <ForgotPasswordForm />
    </TaskyAuthLayout>
  );
};

export default ForgotPasswordPage;
